export interface TenantDomain {
    name: string
    code: string
}

export const TenantModel: TenantDomain = {
    name: "",
    code: ""
}
